import { Link } from "react-router-dom";
import { genres, aboutInfo } from "@/mocks/mv";

export default function Footer() {
  return (
    <footer className="border-t border-background-800 bg-background-900">
      <div className="w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
                <i className="ri-play-circle-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-50">
                红桃<span className="text-primary-400">MV</span>视频
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-400">
              聚合全球最新、最热门的音乐视频，为每一位乐迷提供专业、新鲜的 MV 观看与发现体验。
            </p>
            <div className="mt-4 flex gap-3">
              <a href="#" aria-label="微博" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-800 text-foreground-300 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a href="#" aria-label="微信" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-800 text-foreground-300 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </a>
              <a href="#" aria-label="抖音" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-800 text-foreground-300 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-tiktok-line" aria-hidden="true"></i>
              </a>
              <a href="#" aria-label="B站" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-background-800 text-foreground-300 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-bilibili-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-100">快速导航</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/" className="text-foreground-400 transition-colors hover:text-primary-400">首页</Link></li>
              <li><Link to="/charts" className="text-foreground-400 transition-colors hover:text-primary-400">排行榜</Link></li>
              <li><Link to="/search" className="text-foreground-400 transition-colors hover:text-primary-400">搜索 MV</Link></li>
              <li><Link to="/about" className="text-foreground-400 transition-colors hover:text-primary-400">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-100">音乐风格</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {genres.slice(0, 6).map((g) => (
                <li key={g.code}>
                  <Link to={`/category/${g.code}`} className="text-foreground-400 transition-colors hover:text-primary-400">
                    {g.name} MV
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-foreground-100">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-400" aria-hidden="true"></i>
                {aboutInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base text-primary-400" aria-hidden="true"></i>
                {aboutInfo.phone}
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-primary-400" aria-hidden="true"></i>
                <span>{aboutInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 红桃MV视频 版权所有 · 本站内容仅供演示</p>
          <p>音乐视频聚合与观看平台 · 用心为乐迷服务</p>
        </div>
      </div>
    </footer>
  );
}